import * as React from 'react';
import ErrorText from "../../atom/text/error_text";
import FormCheckbox from "../../atom/form/form_checkbox";
import styled from "styled-components";
import {
    ConstBorderRound,
    ConstColor,
    ConstFontStyle,
    ConstFontWeight
} from "../../../../config/styles_const/styles_const";

interface IProps {
    name: string;
    label: string;
    hasError: boolean;
    errorText: string;
    input?: any;
    customOnChange?: (event: any) => void;
}

const FormGroupCheckbox: React.FC<IProps> = (props) => {

    const { name, label, hasError, errorText, input, customOnChange} = props;

    const onChange = (event: any) => {
        if (customOnChange) {customOnChange(event)}
        input.onChange(event);
    };

    return (
        <Wrapper>
            <FormCheckbox
                {...input}
                id={name}
                type={"checkbox"}
                onChange={onChange}
                checked={input.value}
                hasError={hasError}
            />
            <CheckboxLabel htmlFor={name} >
                <CheckboxLabelText>
                    {label}
                </CheckboxLabelText>
            </CheckboxLabel>
            {hasError &&
            <ErrorText>{errorText}</ErrorText>
            }
        </Wrapper>
    );
};

export default (FormGroupCheckbox);

const height = "26px";

const CheckboxLabelText = styled.span`
    display: inline-block;
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${ConstFontStyle.LabelDefault.fontWeight};
    font-size: ${ConstFontStyle.LabelDefault.fontSize};
    line-height: ${ConstFontStyle.LabelDefault.lineHeight};
    margin-bottom: 0;
    height: ${ConstFontStyle.LabelDefault.lineHeight};
    & a {
        color: ${ConstColor.Corporate};
        font-weight: ${ConstFontWeight.BOLD}
    }
`;

const CheckboxLabel = styled.label`
`;

const Wrapper = styled.div`
    min-height: ${height}; // checkboxの大きさ指定しておきlabel文字をvertical-align: middle;で上下余白をコントロールする
    position: relative;
    & ${FormCheckbox}{
        // 元のcheckboxをdisplay: none;のみで消すとtabが聞かずfocusができないための処理
        /* 透明度0 */
        opacity:0;
        /* ブラウザのデフォルトのスタイルを削除 */
        appearance: none;
        /* レイアウトから無視 */
        position: absolute;
    }
    & ${CheckboxLabel}{
        padding-left: 36px;
        position:relative;
        height: ${height};
        display: flex;
        align-items: center;
    }
    & ${CheckboxLabel}::before{
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: ${height};
        height: ${height};
        border: 1px solid ${ConstColor.Gray};
        border-radius: ${ConstBorderRound.CornerRoundAll};
    }
    & ${FormCheckbox}:focus + ${CheckboxLabel}::before{
        border: 1px solid ${ConstColor.Focus};
    }
    & ${FormCheckbox}:checked + ${CheckboxLabel}::before{
        border: 1px solid ${ConstColor.PlaceholderAndBorder};
    }
    & ${FormCheckbox}:checked + ${CheckboxLabel}::after{
        content: "";
        display: block;
        position: absolute;
        top: 6px;
        left: 6px;
        width: 13px;
        height: 7px;
        transform: rotate(-45deg);
        border-bottom: 3px solid ${ConstColor.Corporate};
        border-left: 3px solid ${ConstColor.Corporate};
    }  
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_checkbox.tsx